
class UtilityClass {

    URL_BASE = process.env.VUE_APP_URL_BASE
    URL_SAVE = process.env.VUE_APP_URL_SAVE

}

export default new UtilityClass();